import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { AccountancyGridQuery, AccountancyGridQueryHandlerBase } from '@skylab-shared/business';
export { AccountancyGridQueryHandlerBase };

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(AccountancyGridQuery)
@Wrapper(AccountancyGridQueryHandlerBase)
export class AccountancyGridQueryHandler {
    public constructor(
        http: Http
    ) { }
}
